<template>
  <!-- Page Content -->
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header"><i class="fa fa-users fa-fw"></i>Usuários</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <div v-if="msg !== null" class="alert alert-info">
        <span><i class="fa fa-bell fa-fw"></i>{{ msg }}</span>
      </div>
      <!-- /.row -->
      <div class="row">
        <div class="pull-right" style="display: none">
          <a
            class="btn btn-default"
            @click="
              addButton.seeForm = !addButton.seeForm;
              user = {};
            "
          >
            <span v-if="addButton.seeForm">
              <i class="fa fa-search fa-fw"></i>Buscar
            </span>
            <span v-else> <i class="fa fa-plus fa-fw"></i> Adicionar </span>
          </a>
          <br />
          <br />
          <br />
        </div>

        <div class="col-lg-12">
          <form
            v-if="addButton.seeForm"
            role="form"
            @submit.stop.prevent="send"
          >
            <input v-model="user.id" type="hidden" />

            <div class="form-group">
              <label>Nome</label>
              <input class="form-control" v-model="user.nome" />
            </div>

            <div class="form-group">
              <label>Email</label>
              <input class="form-control" v-model="user.email" />
            </div>

            <div class="form-group">
              <label>Perfil</label>
              <select class="form-control" v-model="user.profiles[0].id">
                <option
                  v-for="profile in profiles"
                  :key="profile.id"
                  v-bind:value="profile.id"
                >
                  {{ lang.t(profile.name) }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Setor</label>
              <select class="form-control" v-model="user.sectorId">
                <option
                  v-for="sector in sectors"
                  :key="sector.id"
                  v-bind:value="sector.id"
                >
                  {{ sector.name }}
                </option>
              </select>
            </div>
            <button type="submit" class="btn btn-block btn-info">Salvar</button>
          </form>
          <form v-else>
            <div class="form-group">
              <input
                v-model="search"
                class="form-control"
                placeholder="Buscar..."
                @keyup="busca(search)"
              />
            </div>
          </form>
        </div>
      </div>
      <hr />
      <div class="row">
        <div v-if="users.length">
          <table class="table table-bordered table-striped table-hover">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>Email</th>
                <th>Perfil</th>
                <th>Estado</th>
                <th>Acessado em</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="user in users"
                :key="user.id"
                @mouseover="showByIndex = user.id"
                @mouseout="showByIndex = null"
              >
                <td>{{ user.id }}</td>
                <td>{{ user.nome }}</td>
                <td>{{ user.email }}</td>
                <td>
                  <div class="label label-info">
                    {{
                      user.profiles.length ? lang.t(user.profiles[0].name) : ""
                    }}
                  </div>
                </td>
                <td>
                  <div v-if="user.enabled" class="label label-info">ativo</div>
                  <div v-else class="label label-danger">desativado</div>
                </td>
                <td>
                  <div v-if="user.lastLogin !== null">{{ new Date(user.lastLogin).toLocaleString('pt-BR') }}</div>
                  <div v-else>-</div>
                </td>

                <td>
                  <span v-visible="showByIndex === user.id">
                    <a
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Editar"
                      @click.stop="edit(user.id)"
                      class="btn btn-sm btn-primary"
                    >
                      <i class="fa fa-pencil fa-fw"></i>
                    </a>
                    <a
                      @click="
                        showModal = 2;
                        show = showByIndex;
                      "
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Excluir"
                      class="btn btn-sm btn-danger"
                    >
                      <i class="fa fa-trash fa-fw"></i>
                    </a>
                    <a
                      v-if="!user.enabled"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Habilitar Usuário"
                      class="btn btn-sm btn-success"
                      @click="enable(user)"
                    >
                      <i class="fa fa-unlock fa-fw"></i>
                    </a>
                    <a
                      v-else
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Desabilitar Usuário"
                      class="btn btn-sm btn-danger"
                      @click="disable(user)"
                    >
                      <i class="fa fa-lock fa-fw"></i>
                    </a>
                    <a
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Atualizar Senha"
                      @click="
                        showModal = 1;
                        show = showByIndex;
                      "
                      class="btn btn-sm btn-info"
                    >
                      <i class="fa fa-refresh fa-fw"></i>
                    </a>
                  </span>
                </td>
                <Modal v-if="showModal === 1 && show === user.id">
                  <i slot="close" @click="showModal = null">&times;</i>
                  <h2 slot="header">
                    <i class="fa fa-refresh fa-fw"></i> Atualizar Senha do(a)
                    usuário(a) <strong>{{ user.nome }}</strong>
                  </h2>
                  <div slot="body">
                    <div v-if="warning !== null" class="alert alert-danger">
                      <span><i class="fa fa-bell fa-fw"></i>{{ warning }}</span>
                    </div>
                    <form>
                      <div class="col-sm-6">
                        <label>Senha</label>
                        <input
                          class="form-control"
                          v-model="user.senha"
                          type="password"
                        />
                      </div>
                      <div class="col-sm-6">
                        <label>Confirmar Senha</label>
                        <input
                          class="form-control"
                          v-model="user.confirmSenha"
                          type="password"
                        />
                      </div>
                    </form>
                  </div>
                  <div slot="footer">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="
                      changePassword(user)
                      "
                    >
                      Salvar
                    </button>
                    <button class="btn btn-default" @click="showModal = null">
                      fechar
                    </button>
                  </div>
                </Modal>
                <Modal v-if="showModal === 2 && show === user.id">
                  <i
                    slot="close"
                    @click="
                      showModal = null;
                      yes = null;
                    "
                    >&times;</i
                  >
                  <h2 slot="header">
                    <i class="fa fa-times fa-fw"></i>Remover Usuário
                  </h2>
                  <div slot="body">
                    <h4>
                      Deseja realmente remover o Usuário
                      <strong>{{ user.nome }}?</strong>
                    </h4>
                  </div>
                  <div slot="footer">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="
                        yes = true;
                        showModal = null;
                      "
                      @click.stop="remove(user.id)"
                    >
                      Confirmar
                    </button>
                    <button
                      class="btn btn-default"
                      @click="
                        yes = null;
                        showModal = null;
                      "
                    >
                      fechar
                    </button>
                  </div>
                </Modal>
              </tr>
            </tbody>
          </table>
          <nav aria-label="Page navigation" style="text-align: center">
            <ul class="pagination">
              <li>
                <a
                  href="#"
                  @click.prevent.stop="goToPage(pageable.pageNumber - 1)"
                >
                  <span> &laquo; Anterior</span>
                </a>
              </li>
              <li>
                <a href="#">{{ pageable.pageNumber+1 }}/{{ totalPages }}</a>
              </li>
              <li v-if="pageable.pageNumber === totalPages">
                <a
                  href="#"
                >
                  <span>Proxima &raquo; </span>
                </a>
              </li>
              <li v-else>
                <a
                  href="#"
                  @click.prevent.stop="goToPage(pageable.pageNumber + 1)"
                >
                  <span>Proxima &raquo; </span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <Modal v-if="showModal === 3">
          <i slot="close" @click="showModal = null">&times;</i>
          <h2 slot="header">
            <i class="fa fa-times fa-fw"></i>Exclusão de Usuário
          </h2>
          <div slot="body">
            <div
              class="alert alert-success alert-small"
            ><i class="fa fa-exclamation"></i>
              Usuário excluído com sucesso!
            </div>
          </div>
          <div slot="footer">
            <button class="btn btn-default" @click="showModal = null">
              Ok
            </button>
          </div>
        </Modal>
        <div v-else-if="!users.length">
          <div class="alert alert-info">
            <p>
              <i class="fa fa-exclamation fa-fw"></i>Nenhum usuário foi
              encontrado
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- /.container-fluid -->
  </div>
</template>

<script>
import Modal from "../../components/ui-elements/Modal.vue";
import lang from "../../mixins/pt-br";

export default {
  name: "User",
  inject: ["loading"],
  components: { Modal },
  data() {
    return {
      lang,
      search: "",
      addButton: { seeForm: false },
      user: { senha: "", confirmSenha: "" },
      users: [],
      sectors: [],
      profiles: [],
      sector: {},
      sectors: [],
      showByIndex: null,
      show: null,
      showModal: null,
      msg: null,
      warning: null,
      yes: null,
      pageable: {},
      totalPages: null,
      totalElements: null,
      size: null,
    };
  },
  mounted() {
    this.$http.get('sector')
      .then(response => {
        this.sectors = response.data.content
        this.goToPage();
        this.busca();
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    goToPage(page) {
      if (page == undefined) {
        page = 0;
      }

      this.$http.get("profile").then((response) => {
        this.profiles = response.data.content;
        this.$http.get("sector").then((response) => {
            this.sectors = response.data.content;
          })
        this.$http
          .get(`user?page=${page}&orderBy=id`)
          .then((response) => {
            this.loading.value = true;
            this.users = response.data.content;
            this.pageable = response.data.pageable;
            this.totalPages = response.data.totalPages;
            this.totalElements = response.data.totalElements;
            this.size = response.data.size;
            if (this.pageable.pageNumber > this.totalPages) {
              this.pageable.pageNumber = this.totalPages;
            }

            setTimeout(() => (this.loading.value = false), 1000);
          })
          .finally(() => {
            this.$nextTick(() => {
              $('[data-toggle="tooltip"]').tooltip();
            });
            setTimeout(() => (this.loading.value = false), 1000);
          });
      });
    },
    busca() {
      const queryString = this.search ? `?name=${this.search}` : "";
      this.$http.get(`user${queryString}`).then((response) => {
        this.users = response.data.content;
      })
      .catch(error => console.log(error))
      .finally( () => console.log('fim da pesquisa de usuarios') )
      
    },
    enable(user) {
      this.loading.value = true;
      user.enabled = true;

      this.$http
        .put(`user/${user.id}`, user)
        .then((reponse) => {
          if(this.user.enabled){
            this.msg = "usuario ativado com sucesso";
          }else{
            this.user.enabled = true;
            this.msg = "usuario ativado com sucesso";
          }
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setTimeout(() => (this.loading.value = false), 1000);
        });
    },
    disable(user) {
      this.loading.value = true;
      user.enabled = false;

      this.$http
        .put(`user/${user.id}`, user)
        .then((reponse) => {
          if(this.user.enabled == false){
            this.msg = "usuario desativado com sucesso";
          }else{
            this.user.enabled = false;
            this.msg = "usuario desativado com sucesso";
          }
          
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setTimeout(() => (this.loading.value = false), 1000);
        });
    },
    send() {
      this.loading.value = true;
      if (this.user.id) {
        this.$http
          .put(`/user/${this.user.id}`, this.user)
          .then((response) => {
            this.users = this.users.filter((item) => item.id != this.user.id);
            this.users.push(response.data);
            this.user = {};
            this.addButton.seeForm = false;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$http
          .post("user", this.user)
          .then((response) => {
            this.user = {};
            this.users.push(response.data);
            this.addButton.seeForm = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
      setTimeout(() => (this.loading.value = false), 1000);
    },
    edit(id) {
      this.loading.value = true;
      this.$http
        .get(`user/${id}`)
        .then((response) => {
          this.addButton.seeForm = true;
          this.user = response.data;

          if (!this.user.profiles.length) {
            this.user.profiles = [];
            this.user.profiles.push({ id: 2, name: "ROLE_USER" });
          }

          if (this.user.confirmSenha !== this.user.senha) {
            this.msg = "Senhas diferentes, por favor repita!";
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.msg = null;
      setTimeout(() => (this.loading.value = false), 1000);
    },
    changePassword(user) {
      if(user.senha === user.confirmSenha){
        this.loading.value = true
        this.$http.post(`user/update-password/${user.id}`, { password : user.senha })
          .then((response) => {
            if(response.status === 200){
              this.msg = "Senha alterada com sucesso"
              this.showModal = null
            }else{
              this.msg = "Falha ao alterar senha"
            }
          })
          .catch((error) => console.log(error))
          .finally(() => {
            setTimeout(() => (this.loading.value = false), 1000);
          });
      } else {
        this.warning = "Senhas diferentes, por favor repita!"
      }
    },
    remove(id) {
      this.loading.value = true;

      const confirm = this.yes;

      if (confirm) {
        this.$http
          .delete(`user/${id}`)
          .then((response) => {
            this.users = this.users.filter((item) => item.id != id);
            this.showModal = 3;
          })
          .catch((error) => alert(error));
      }
      setTimeout(() => (this.loading.value = false), 1000);
    },
  },
  computed: {
   
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Users.vue